import { createContext, useContext, useMemo, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

import {
  getWorkspaceLabels,
  resolveWorkspacePortalMode,
  type WorkspaceLabels,
  type WorkspacePortalMode,
} from '@/lib/workspace-labels'

const WorkspacePortalContext = createContext<WorkspaceLabels>(getWorkspaceLabels('job'))

type WorkspacePortalProviderProps = {
  mode?: WorkspacePortalMode
  children: ReactNode
}

export function WorkspacePortalProvider({ mode, children }: WorkspacePortalProviderProps) {
  const location = useLocation()
  const labels = useMemo(
    () => getWorkspaceLabels(resolveWorkspacePortalMode(location.pathname, mode)),
    [location.pathname, mode],
  )

  return (
    <WorkspacePortalContext.Provider value={labels}>
      {children}
    </WorkspacePortalContext.Provider>
  )
}

export function useWorkspaceLabels(): WorkspaceLabels {
  return useContext(WorkspacePortalContext)
}

export function useWorkspacePortalMode(): WorkspacePortalMode {
  return useWorkspaceLabels().mode
}
